import api from './api';
import { DashboardResponse } from '../types/dashboard';

export const getDashboardSummary = async (): Promise<DashboardResponse> => {
    const response = await api.get('/dashboard');
    return response.data;
};
